import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

var $entryElements = jQuery('[data-entry-id]');
var menu = jQuery.map($entryElements, item => jQuery(item).data('entryId'));

let swiper = new Swiper('.jumbotron-reference .swiper-container', {
  modules: [Navigation, Pagination],
  effect: 'fade',
  loop: true,
  speed: 900,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.jumbotron-reference .swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<div class="' + className + '"><span>' + (menu[index]) + '</span></div>';
    },
  },
  grabCursor: true,
});
